<div class="page-header">
    <div class="row">
        <h3>نقطه شروع</h3>
    </div>
</div>
<article>
    <section class="page-section-1">
        <div class="row">
            <p style="text-align: justify;"><span
                    style="color: #000000; font-size: 17pt; padding-bottom: 5px; border-bottom: 3px solid #aa0304;">نقطه
                    شروع</span></p>
            <div class=" ">
                <div class="columns medium-12 columns">
                    <p></p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">در صورتیکه تصمیم دارید مدیریت سرمایه
                        خود را به افراد حرفه ای بسپارید، می توانید براساس اهداف سرمایه گذاری خود نسبت به تشکیل <strong><a href="/services/dedicated-investment-management" target="_blank">
                            سبد اختصاصی</a></strong>
                        و یا سرمایه‌گذاری در <strong><a href="/services/management-investment-funds" target="_blank">صندوق های سرمایه گذاری مشترک </a></strong>
                        اقدام نمایید. در ادامه توضیحات مربوط به هر یک از روش های مدیریت حرفه ای سرمایه ارائه گردیده است.
                    </p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        همچنین جهت تصمیم گیری در خصوص روش مناسب سرمایه گذاری پیشنهاد ما این است از طریق تعیین وقت مشاوره
                        از راهنمایی مشاوران شرکت سبدگردان آبان استفاده نمایید.
                    </p>
                </div>
            </div>
            <p>&nbsp;</p>
            <p style="text-align: justify;"><span
                    style="color: #000000; font-size: 17pt; padding-bottom: 5px; border-bottom: 3px solid #aa0304;">سرمایه
                    گذاری در صندوق های سرمایه گذاری مشترک</span></p>
            <div class=" ">
                <div class="columns medium-12 ">
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        در این روش سرمایه خرد افراد در صندوق‌ها، جمع‌آوری شده و توسط مدیران با تجربه و حرفه‌ای در دارایی
                        هایی نظیر سهام، اوراق مشارکت، سپرده‌های بانکی و… سرمایه‌گذاری خواهد شد.
                    </p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">بر اساس نحوه تخصیص منابع مالی بین
                        دارایی‌های مختلف، صندوق‌های سرمایه‌گذاری به انواع گوناگونی تقسیم می‌شوند. هر یک از این صندوق‌ها
                        برای گروه متفاوتی از سرمایه‌گذاران با اهداف مالی و درجه ریسک‌پذیری متفاوت مناسب هستند. در حال
                        حاضر طیف گسترده ای از صندوق ها در بازار وجود دارد این طیف صندوق هایی با درجه ریسک پایین که مشابه
                        سرمایه گذاری بانکی است تا صندوق هایی با ریسک بالا که مشابه سرمایه گذاری در سهام شرکت ها می باشد
                        را شامل می گردد. </p>
                    <p style="text-align: justify;font-size: 14pt; color: #000000;">
                        صندوق درآمد ثابت
                    </p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        سپرده‌های بانکی و اوراق با درآمد ثابت عمده دارایی‌های صندوق درآمد ثابت است. با این وجود، مدیران
                        صندوق برای تحقق سود بیشتر بخش اندکی از این منابع را صرف سرمایه‌گذاری در سهام شرکت‌ها می‌کنند.
                        این صندوق ها از درجه ریسک پایینی برخوردار بوده و در مقابل بازدهی کمتری را نسبت به سایر صندوق ها
                        خواهد داشت.
                    </p>
                    <p style="text-align: justify;font-size: 14pt; color: #000000;">
                        صندوق سهامی
                    </p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        این نوع از صندوق های سرمایه‌گذاری مناسب آن دسته از افرادی است که برای دستیابی به بازدهی بالاتر،
                        ریسک بیشتری را متحمل می شوند. بیش از ۷۰ درصد دارایی های این صندوق به سهام شرکت ها اختصاص می یابد
                        بنابراین بازدهی این صندوق ها از نوسانات بالایی برخوردار است و در ازای ریسک بیشتر امکان تحقق
                        بازدهی بالاتر را فراهم می نمایند.
                    </p>
                    <p style="text-align: justify;font-size: 14pt; color: #000000;">
                        صندوق مختلط
                    </p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        ریسک این صندوق ها از صندوق های سهامی کمتر و از صندوق های درآمد ثابت بیشتر است و در مقابل بازدهی
                        آن نیز می تواند از صندوق درآمد ثابت بالاتر و از صندوق های سهامی کمتر باشد. دارایی های
                        این صندوق حداقل ۴۰ درصد و حداکثر ۶۰ درصد به سهام شرکت ها و مابقی به دارایی های کم ریسک مانند
                        اوراق درآمد ثابت و سپرده بانکی و .... اختصاص دارد. بنابراین براساس ترکیب دارایی ها، این صندوق
                        ها در درجه ریسک متوسط برخوردار هستند.
                    </p>


                </div>
            </div>


            <p>&nbsp;</p>
            <p style="text-align: justify;"><span
                    style="color: #000000; font-size: 17pt; padding-bottom: 5px; border-bottom: 3px solid #aa0304;">سرمایه
                    گذاری به روش سبد اختصاصی:</span></p>
            <div class=" ">
                <div class="columns medium-12 ">
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        روش دیگر سرمایه گذاری غیر مستقیم تشکیل سبد اختصاصی است. در این روش کارشناسان و مشاوران شرکت سبد
                        گردان آبان در یک نشست صمیمی میزان ریسک پذیری فرد را براساس پارامتر های تخصصی اندازه گیری می
                        نمایند. سرمایه‌گذاران منابع مالی خود را در اختیار یک تیم حرفه‌ای که دانش بالایی از سرمایه‌گذاری
                        دارند، قرار می دهند و این افراد براساس میزان سرمایه، اهداف و نیازهای سرمایه گذاری به خرید دارایی
                        و تشکیل سبد متناسب با ویژگی های خاص سرمایه گذار اقدام می نمایند. در این روش کارشناسان ما علاوه
                        بر ارائه گزارشات دوره ای از عملکرد سبد اختصاصی آماده ارائه توضیحات مورد نیاز سرمایه گذاران و حفظ
                        ارتباط متداوم با ایشان هستند.</p>
                    <p style="text-align: justify;font-size: 12pt; color: #000000;">
                        در انتها پیشنهاد می گردد جهت انتخاب روش مناسب مدیریت سرمایه از خدمات مشاوره ما استفاده نمایید.
                        مشاوران ما جهت ارائه راهنمایی های لازم همواره در کنار شما هستند.
                    </p>


                </div>
            </div>




            <!-- <div class="medium-12 column" style="margin-top: 2rem;text-align: justify;">
                <p style=" padding-bottom: 5px;font-size: 12pt;">

                </p>
                <div class="row" style="margin-top: 2rem;">
                    <div class="meduim-12 ">
                        <div class="medium-6 column" style="text-align: center; margin-bottom: 2rem;">


                            <button class="wpfs button primary radius tiny2"
                                routerLink="/services/dedicated-investment-management" routerLinkActive="active">
                                مدیریت اختصاصی سرمایه‌گذاری
                            </button>
                        </div>

                        <div class="medium-6 column" style="text-align: center;">

                            <button class="wpfs button primary radius tiny2"
                                routerLink="/services/management-investment-funds" routerLinkActive="active">
                                مدیریت صندوق های سرمایه‌گذاری
                            </button>

                        </div>

                    </div>
                </div>
            </div> -->
        </div>
    </section>
</article>